/* Nexus v22 · Designed by Kavalsia Inc. · Author: Siavash Sadighi
   Never crop a photo.
   1) Frames follow the photos: each product gallery, and each row of menu collection cards, takes the shape
      of its tallest photo, so photos show in full with no fill.
   2) Last resort only: a photo that still can't fit its frame (a landscape photo in a row with a portrait one)
      shows in full over a blurred copy of itself, its edges faded in. Every other photo is left untouched.
   Styles: snippets/nx-media-fill.liquid */
(function () {
  if (window.__nxFill) return; window.__nxFill = true;
  var SEL = '.product-media-container .product-media__image, .resource-card__image';
  var FADE = 24;
  var seen = new WeakSet();
  var ro = 'ResizeObserver' in window ? new ResizeObserver(function (es) { es.forEach(function (e) { fit(e.target); }); }) : null;

  function ratioOf(img) {
    var w = +img.getAttribute('width') || img.naturalWidth, h = +img.getAttribute('height') || img.naturalHeight;
    return w && h ? w / h : 0;
  }
  function tallest(imgs) {
    var r = 0;
    imgs.forEach(function (i) { var x = ratioOf(i); if (x && (!r || x < r)) r = x; });
    return r;
  }

  /* 1) Frames follow the photos */
  function frames() {
    document.querySelectorAll('media-gallery').forEach(function (g) {
      var r = tallest(g.querySelectorAll('.product-media-container .product-media__image'));
      if (!r) return;
      var v = r.toFixed(4);
      if (g.dataset.nxFrame !== v) { g.dataset.nxFrame = v; g.style.setProperty('--nx-frame', v); g.classList.add('nx-frame'); }
    });
    var lists = new Set();
    document.querySelectorAll('.resource-card__image').forEach(function (i) { var ul = i.closest('ul'); if (ul) lists.add(ul); });
    lists.forEach(function (ul) {
      var imgs = ul.querySelectorAll('.resource-card__image');
      var r = tallest(imgs);
      if (!r) return;
      var v = r.toFixed(4);
      imgs.forEach(function (i) {
        var m = i.closest('.resource-card__media');
        if (m && m.dataset.nxFrame !== v) { m.dataset.nxFrame = v; m.style.setProperty('--resource-card-aspect-ratio', v); }
      });
    });
  }

  /* 2) Last-resort fill */
  function small(src) {
    if (!src) return '';
    return /[?&]width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=160') : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
  }
  function fit(img) {
    var box = img.parentElement;
    if (!box) return;
    var bw = img.clientWidth, bh = img.clientHeight, nw = img.naturalWidth || +img.getAttribute('width'), nh = img.naturalHeight || +img.getAttribute('height');
    if (!bw || !bh || !nw || !nh) return;
    var r = nw / nh, b = bw / bh;
    var on = Math.abs(r / b - 1) > 0.04;
    box.classList.toggle('nx-fill', on);
    img.classList.toggle('nx-fill__img', on);
    if (!on) return;
    var w = Math.min(bw, bh * r), h = Math.min(bh, bw / r);
    var x0 = (bw - w) / 2, y0 = (bh - h) / 2, s = box.style;
    s.setProperty('--nx-x0', x0.toFixed(1) + 'px');
    s.setProperty('--nx-xf', (x0 > 1 ? FADE : 0) + 'px');
    s.setProperty('--nx-y0', y0.toFixed(1) + 'px');
    s.setProperty('--nx-yf', (y0 > 1 ? FADE : 0) + 'px');
    var bg = box.querySelector(':scope > .nx-fill__bg');
    if (!bg) { bg = document.createElement('span'); bg.className = 'nx-fill__bg'; bg.setAttribute('aria-hidden', 'true'); box.insertBefore(bg, img); }
    var src = small(img.currentSrc || img.src);
    if (bg.dataset.src !== src) { bg.dataset.src = src; bg.style.backgroundImage = 'url("' + src.replace(/"/g, '%22') + '")'; }
  }
  function track(img) {
    if (seen.has(img)) {
      if (img.classList.contains('nx-fill__img') && !(img.parentElement && img.parentElement.querySelector(':scope > .nx-fill__bg'))) fit(img);
      return;
    }
    seen.add(img);
    if (getComputedStyle(img).objectFit !== 'cover') return;
    img.addEventListener('load', function () { fit(img); });
    if (ro) ro.observe(img);
    if (img.complete) fit(img);
  }

  function scan() { frames(); document.querySelectorAll(SEL).forEach(track); }
  scan();
  var queued = false;
  new MutationObserver(function () {
    if (queued) return; queued = true;
    requestAnimationFrame(function () { queued = false; scan(); });
  }).observe(document.body, { childList: true, subtree: true });
  addEventListener('resize', function () { document.querySelectorAll('.nx-fill__img').forEach(fit); }, { passive: true });
})();